export default "__VITE_PUBLIC_ASSET__9aa7648d__"